import {
  Button,
  CardHeader,
  DataGrid,
  Dialog,
  DialogActions,
  DialogContent,
} from "../../../../components";

const CodigoBarraRepetidosDialog = ({
  open,
  setOpen,
  produtosCodigosRepetidos,
  produtosCodigosBarraRepetidos,
  handleInitStep,
}) => {
  const colunasCodigosBarra = [
    {
      field: "codigoBarra",
      headerName: "Código de Barra",
      sortable: false,
      flex: 150,
    },
    {
      field: "descricao",
      headerName: "Produto",
      sortable: false,
      flex: 400,
    },
  ];

  const colunasCodigos = [
    {
      field: "codigo",
      headerName: "Código",
      sortable: false,
      flex: 150,
    },
    {
      field: "descricao",
      headerName: "Produto",
      sortable: false,
      flex: 400,
    },
  ];

  function onClose() {
    handleInitStep();
    setOpen(false);
  }

  return (
    <Dialog fullWidth maxWidth={"md"} open={open} onClose={onClose}>
      <DialogContent>
        {produtosCodigosRepetidos?.length > 0 && (
          <>
            <CardHeader
              title="CÓDIGOS REPETIDOS"
              sx={{ margin: "16px 0px !important" }}
            />
            <DataGrid
              rows={produtosCodigosRepetidos}
              columns={colunasCodigos}
              rowCount={produtosCodigosRepetidos.length}
              disableAcoes
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 5,
                  },
                },
              }}
            />
          </>
        )}
        {produtosCodigosBarraRepetidos?.length > 0 && (
          <>
            <CardHeader
              title="CÓDIGOS DE BARRAS REPETIDOS"
              sx={{ margin: "16px 0px !important" }}
            />
            <DataGrid
              rows={produtosCodigosBarraRepetidos}
              columns={colunasCodigosBarra}
              rowCount={produtosCodigosBarraRepetidos.length}
              disableAcoes
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 5,
                  },
                },
              }}
            />
          </>
        )}
      </DialogContent>
      <DialogActions
        sx={{
          overflow: "auto",
          position: "sticky",
          bottom: 0,
          margin: 1,
          backgroundColor: "white",
        }}
      >
        <Button
          color="padrao"
          margin="normal"
          variant="contained"
          onClick={onClose}
          disableElevation
        >
          <i
            className="ph-fill ph-x-circle"
            style={{ fontSize: 22, marginRight: 10 }}
          ></i>
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CodigoBarraRepetidosDialog;
